import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

// import base64ToImage from 'base64-to-image';
const INITIAL_STATE = {
  'images': [],
  'loading': false,
};

const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};

const convertBase64ToFiles = (attachments) => {
  const files = [];
  attachments.forEach((item) => {
    const base64 = `data:image/jpeg;base64, ${item.file}`;
    urltoFile(base64, item.name, item.mimetype).then((file) => {
      files.push(file);
    });
  });
  return files;
};

export const vehicleCertificationImages = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_IMAGE_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_IMAGE_VEHICLE_CERTIFICATION]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'images': convertBase64ToFiles(action.response.data.attachments),
      };
    },
    [ActionTypes.FETCHED_IMAGE_VEHICLE_CERTIFICATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'images': [],
    }),
    [ActionTypes.CLEAR_IMAGES_VEHICLE_CERTIFICATION]: (state, action) => ({
      ...state,
      'loading': false,
      'images': [],
    }),
  })(state, action);
};
